<label for="svgimgupload">
  <img
    id="imgFilePreview"
    class="s-user-profile-persona"
    [src]="imageSRC ? imageSRC : '../../../assets/images/icon-default-logo-preview.svg'"
    style="cursor: pointer;"
  />
</label>
<input
  type="file"
  id="svgimgupload"
  [accept]="allowedTypes"
  class="upload"
  (change)="onUploadImage($event)"
  hidden
/>
